import React, { useState } from 'react';
import Modal from 'react-modal';
import { Box, IconButton } from 'theme-ui';
import { FaBars } from 'react-icons/fa';
import './styles.css';

const styles = {
  panelContent: {
    height: '100%',
    zIndex: 2,
    bg: 'contentBg',
    overflowY: 'scroll',
  },
  openButton: {
    // display: ['', '', 'none'], //to avoid ssr rehydration issue
    marginLeft: 'auto',
    verticalAlign: 'middle',
  },
  closeButton: {
    background: 'transparent',
    ':hover': {
      background: 'transparent',
    },
    position: 'fixed',
    zIndex: 99999,
    right: '32px',
    top: '12px',
    color: 'gray700',
    '& svg': {
      height: '16px',
    },
  },
};

const Drawer = ({ children, buttonStyle }) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          ...styles.openButton,
          ...buttonStyle,
          display: open ? 'none' : 'block',
        }}
        aria-label='Open Drawer'
      >
        <FaBars />
      </Box>
      <Modal
        isOpen={open}
        onRequestClose={handleClick}
        closeTimeoutMS={300}
        contentLabel='Drawer'
        className='DrawerPortalContent'
        overlayClassName='DrawerPortalOverlay'
      >
        <Box sx={styles.panelContent}>
          <IconButton
            onClick={handleClick}
            sx={{ ...styles.closeButton, ...buttonStyle }}
            aria-label='Close Drawer'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='28'
              height='28'
              viewBox='0 0 28 28'
              fill='none'
            >
              <path
                d='M21 7L7 21M7 7L21 21'
                stroke='#344054'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </IconButton>
          {children}
        </Box>
      </Modal>
    </>
  );
};

export default Drawer;
